<template>   
    <v-row>
       <v-col class="justify-center">
           <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"            
            color="green"
            @click.stop="onClickStatus(1)"
            >Actif</v-chip>

            <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"
            color="blue"
            @click.stop="onClickStatus(0)"
            >En commande</v-chip>

            <v-chip
            :small="!xSmall"
            :x-small="xSmall"
            class="white--text ma-2 status-chip"
            color="red"
            @click.stop="onClickStatus(2)"
            >Hors parc</v-chip>
       </v-col>       
    </v-row>      
</template>

<script>
export default {
  name: 'AVehicleStatusChanger',   
  props: {        
    xSmall: {
      type: Boolean,
      value: true
    },
  },
  data: () => ({
   
  }),
  methods: {
    onClickStatus: function(status) {
      this.$emit("clickStatus", status)
    }
  }
}
</script>
